import React, { useCallback, Fragment } from 'react';
import { useController } from 'react-hook-form';
import CodeEditor from '../code-editor';
import FieldStatus from '../field-status';
import validateProhibitedHTMLTags from './helpers/validate-prohibited-html-tags';
import validateWsAssets from './helpers/validate-ws-assets';
let EXTRA_VALIDATION = false;

const defaultRules = {};

const CodeEditorField = ({
  name,
  control,
  rules = defaultRules,
  onChange = Function.prototype,
  onBlur = Function.prototype,
  onEditorError = Function.prototype,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (value) => {
      field.onChange(value);
      onChange(value);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(
    (event) => {
      field.onBlur();
      onBlur(event);
    },
    [field, onBlur]
  );

  const validateEditorCode = useCallback(
    ({ annotations = [], value, session }) => {
      let editorAnnotations = annotations;

      if (EXTRA_VALIDATION) {
        return;
      }

      const wsAssetsErrors = session ? validateWsAssets({ value, session }) : [];
      const prohibitedHTMLTagsErrors = session
        ? validateProhibitedHTMLTags({ value, session })
        : [];

      editorAnnotations = annotations.concat(wsAssetsErrors, prohibitedHTMLTagsErrors);

      EXTRA_VALIDATION = true;
      session.setAnnotations(editorAnnotations);
      EXTRA_VALIDATION = false;

      const error = editorAnnotations.find((annotation) => annotation.type === 'error');

      if (error) {
        const { text, row, column } = error;
        const errorText = `Line ${row + 1}, Column ${column}: ${text}`;
        onEditorError(errorText);
        return;
      }

      onEditorError('');
    },
    [onEditorError]
  );

  return (
    <Fragment>
      <CodeEditor
        {...otherProps}
        value={field.value}
        invalid={fieldState.invalid}
        onChange={handleChange}
        onBlur={handleBlur}
        onValidate={validateEditorCode}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </Fragment>
  );
};

export default CodeEditorField;
